export const screenReaderInstructions = {
  draggable: `
    To pick up a draggable item, press enter or space.
    Use the arrow keys to move the item.
    Press enter or space again to drop the item in its new position, or press escape to cancel.
  `,
};

// https://docs.dndkit.com/guides/accessibility#screen-reader-instructions
// we could memoize this. . .
const cachedContent: { [id: string]: string } = {};

export function getCachedContent(id): string | typeof cachedContent {
  return id ? cachedContent[id] : cachedContent;
}

let tempItems;
let startPosition;
let currentPosition;
let mssg;
let direction;

export function reset() {
  tempItems = null;
  startPosition = null;
  currentPosition = null;
  mssg = null;
  direction = null;
}

export const onKeyDown = e => {
  const { key } = e;

  if (['ArrowUp', 'ArrowDown'].includes(key)) {
    direction = String(key)
      .replace('Arrow', '')
      .toLowerCase();
  }

  if (key === 'Tab') {
    e.preventDefault();
    return;
  }
};

export const getElementContent = (
  id,
  element: HTMLElement | undefined = undefined
) => {
  const item = (element || document).querySelector(id) as HTMLElement;

  if (!item) {
    return '';
  }

  if (cachedContent[id]) {
    return cachedContent[id];
  }

  const text = (item.querySelector('[class*="ReadOnlyText"]') as HTMLElement)
    ?.innerText;

  const imgDescription = item.querySelector('img')?.getAttribute('alt');

  cachedContent[id] = text || imgDescription || '';

  return cachedContent[id];
};

export const announcements = {
  onDragStart({ active }) {
    const draggableContent = getElementContent(
      `#sortation-option-${active.id}`
    );

    mssg = `Picked up sortable item ${draggableContent}`;

    // console.log(mssg);

    return mssg;
  },

  onDragOver(data) {
    //

    if (!direction) {
      return;
    }

    const { active, over } = data;

    if (!tempItems) {
      tempItems = [...active?.data?.current?.sortable?.items];
      currentPosition = startPosition = tempItems.indexOf(active?.id);
    }

    if (direction === 'up' && currentPosition > 0) {
      tempItems.splice(currentPosition, 1);
      currentPosition -= 1;
    }

    if (direction === 'down' && currentPosition < tempItems.length - 1) {
      tempItems.splice(currentPosition, 1);
      currentPosition += 1;
    }

    tempItems.splice(currentPosition, 0, active?.id);

    if (tempItems[currentPosition - 1]) {
      mssg = `${getElementContent(
        `#sortation-option-${active?.id}`
      )} was moved below ${getElementContent(
        `#sortation-option-${tempItems[currentPosition - 1]}`
      )}.`;

      if (currentPosition === tempItems?.length - 1) {
        mssg = mssg.replace('.', '');
        mssg = `${mssg}, and is now the last item in the list.`;
      }
    } else {
      mssg = `${getElementContent(
        `#sortation-option-${active?.id}`
      )} was moved to the top of the list.`;
    }

    // console.log(mssg);

    return mssg;
  },

  onDragEnd() {
    const mssgUpdated = mssg.replace('moved', 'dropped');

    reset();

    // console.log(mssgUpdated);

    return mssgUpdated;
  },

  onDragCancel({ active }) {
    //
    reset();

    const dragCancelledMssg = `Dragging was cancelled. ${getElementContent(
      `#sortation-option-${active.id}`
    )} was returned to its original position.`;

    // console.log(dragCancelledMssg);

    return dragCancelledMssg;
  },
};
